import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
    routes: [
        
        {
            path: '/',
            meta: { title: '字節跳動公益' ,header:true,footer: true,download:true},
            component: () => import('../components/index/index.vue'),
            // children: testRouter
            redirect:'/index/home',
        },
        {
            path: '/index',
            meta: { title: '字節跳動公益',header:true,footer: true ,download:true},
            component: () => import('../components/index/index.vue'),
            redirect:'/index/home',
            children:  [
                {
                    path: 'home',
                    component: () => import('../components/index/home/index.vue'),
                    meta: { title: '字節跳動公益' ,label:'home' ,header:true,footer: true,download:true},
                    // children: orderRouter
                },
                {
                    path: 'about',
                    component: () => import('../components/index/about/index.vue'),
                    meta: { title: '关于我们' ,label:'about' ,header:true,footer: true,download:true},
                    // children: orderRouter
                },
                {
                    path: 'hot',
                    component: () => import('../components/index/hot/index.vue'),
                    meta: { title: '热搜榜' ,label:'hot' ,header:true,footer: true,download:true},
                    // children: orderRouter
                },
                {
                    path: 'new',
                    component: () => import('../components/index/new/index.vue'),
                    meta: { title: '新闻动态' ,label:'new' ,header:true,footer: true,download:true},
                    // children: orderRouter
                },
                {
                    path: 'newcon',
                    component: () => import('../components/index/newcon/index.vue'),
                    meta: { title: '新闻动态详情' ,label:'newcon' ,header:true,footer: true,download:true},
                    // children: orderRouter
                },
                {
                    path: 'joinpage',
                    component: () => import('../components/topage/index.vue'),
                    meta: { title: '全民反诈' ,label:'joinpage',header:false,footer: false,download:false},
                    // children: orderRouter
                },
                
            ]
        },
        {
            path: '/topage',
            component: () => import('../components/topage/index.vue'),
            meta: { title: '字節跳動公益' ,label:'topage' ,header:true,footer: true,download:true},
            // children: orderRouter
        },
        {
            path: '/user',
            meta: { title: '字節跳動公益',header:true,footer: true ,download:true,login:true},
            component: () => import('../components/user/index.vue'),
            redirect:'/user/index',
            children:  [
                {
                    path: 'index',
                    component: () => import('../components/user/index/index.vue'),
                    meta: { title: '字節跳動公益' ,label:'index',header:true,footer: true,download:true,login:true},
                    // children: orderRouter
                },
                {
                    path: 'login',
                    component: () => import('../components/user/login/index.vue'),
                    meta: { title: '欢迎登陆' ,label:'login',header:false,footer: false,download:false,login:false},
                    // children: orderRouter
                },
                {
                    path: 'register',
                    component: () => import('../components/user/register/index.vue'),
                    meta: { title: '注册账号' ,label:'register',header:false,footer: false,download:false,login:false},
                    // children: orderRouter
                },
                {
                    path: 'credit',
                    component: () => import('../components/user/credit/index.vue'),
                    meta: { title: '反诈中心' ,label:'credit',header:false,footer: true,download:false,login:true},
                    // children: orderRouter
                },
                {
                    path: '/user/welfare',
                    component: () => import('../components/user/welfare/index.vue'),
                    meta: { title: '公益榜' ,label:'welfare',header:false,footer: true,download:true,login:true},
                    // children: orderRouter
                },
                {
                    path: 'main',
                    component: () => import('../components/user/main/index.vue'),
                    meta: { title: '个人中心' ,label:'main',header:false,footer: true,download:false,login:true},
                    redirect:'/user/main/index',
                    children:  [
                        {
                            path: '/user/main/index',
                            component: () => import('../components/user/main/index/index.vue'),
                            meta: { title: '个人中心' ,label:'mainindex',header:false,footer: true,download:true,login:true},
                            // children: orderRouter
                        },
                        {
                            path: '/user/main/donation',
                            component: () => import('../components/user/main/donation/index.vue'),
                            meta: { title: '捐赠中心' ,label:'donation',header:false,footer: false,download:false,login:true},
                            // children: orderRouter
                        },
                        {
                            path: '/user/main/cashout',
                            component: () => import('../components/user/main/cashout/index.vue'),
                            meta: { title: '提现申请' ,label:'cashout',header:false,footer: false,download:false,login:true},
                            // children: orderRouter
                        },
                        {
                            path: '/user/main/assistance',
                            component: () => import('../components/user/main/assistance/index.vue'),
                            meta: { title: '助力记录' ,label:'assistance',header:false,footer: false,download:false,login:true},
                            // children: orderRouter
                        },
                        {
                            path: '/user/main/transaction',
                            component: () => import('../components/user/main/transaction/index.vue'),
                            meta: { title: '交易记录' ,label:'transaction',header:false,footer: false,download:false,login:true},
                            // children: orderRouter
                        },
                        {
                            path: '/user/main/security',
                            component: () => import('../components/user/main/security/index.vue'),
                            meta: { title: '安全中心' ,label:'security',header:false,footer: false,download:false,login:true},
                            
                        },
                        {
                            path: '/user/main/updatepwd',
                            component: () => import('../components/user/main/updatepwd/index.vue'),
                            meta: { title: '修改密码' ,label:'updatepwd',header:false,footer: false,download:false,login:true},
                            // children: orderRouter
                        },
                        {
                            path: '/user/main/bank',
                            component: () => import('../components/user/main/bank/index.vue'),
                            meta: { title: '银行卡管理' ,label:'bank',header:false,footer: false,download:false,login:true},
                            // children: orderRouter
                        },
                        {
                            path: '/user/main/addbank/:page_name?',
                            component: () => import('../components/user/main/addbank/index.vue'),
                            meta: { title: '添加银行卡' ,label:'addbank',header:false,footer: false,download:false,login:true},
                            // children: orderRouter
                        },
                        {
                            path: '/user/main/mydonation',
                            component: () => import('../components/user/main/mydonation/index.vue'),
                            meta: { title: '我的捐赠' ,label:'mydonation',header:false,footer: false,download:false,login:true},
                            // children: orderRouter
                        }
                        
                    ]
                },
                
            ]
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});
